(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('MyIDDeleteController',MyIDDeleteController);

    MyIDDeleteController.$inject = ['$uibModalInstance', 'entity', 'MyID'];

    function MyIDDeleteController($uibModalInstance, entity, MyID) {
        var vm = this;

        vm.myID = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MyID.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
